import React from 'react';
import { Container, Navbar } from "react-bootstrap";

const NavTop = () =>{
    return (
        <div className="container">
        <Navbar fixed="top" className="navbar navbar-expand-lg navbar-dark p-md-3">
                <a className="navbar-brand col-sm-3 col-md-2 mr-0" href="http://www.Metaframe.com">
                    <img src="./logo.png" height="105" alt=""/>
                    <img src="./metaframe-small.jpg" height="60" alt=""/>
                </a>
            {/*
            <Container>
                <Nav className="justify-content-end" activeKey="/home">
                    <Nav.Item>
                        <Nav.Link href="/">Home</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link href="/buy">Corwdsale</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Item>
                            <Nav.Link href="/about">About Us</Nav.Link>
                        </Nav.Item>
                    </Nav.Item>
                </Nav>
            </Container>
            */}
        </Navbar>
        </div>
    );
}
export default NavTop;